/**
 * @generated SignedSource<<90569c89d1d03467c02e91146d9fc420>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PlannedItemIdInput = {
  id: string;
};
export type AnalysisForecastPlannedItemsViewDisableMutation$variables = {
  input: PlannedItemIdInput;
};
export type AnalysisForecastPlannedItemsViewDisableMutation$data = {
  readonly disablePlannedItem: {
    readonly enabled: boolean;
    readonly id: string;
  };
};
export type AnalysisForecastPlannedItemsViewDisableMutation = {
  response: AnalysisForecastPlannedItemsViewDisableMutation$data;
  variables: AnalysisForecastPlannedItemsViewDisableMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PlannedItem",
    "kind": "LinkedField",
    "name": "disablePlannedItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisForecastPlannedItemsViewDisableMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisForecastPlannedItemsViewDisableMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bd4958f70f2f0379101592a5d09b8944",
    "id": null,
    "metadata": {},
    "name": "AnalysisForecastPlannedItemsViewDisableMutation",
    "operationKind": "mutation",
    "text": "mutation AnalysisForecastPlannedItemsViewDisableMutation(\n  $input: PlannedItemIdInput!\n) {\n  disablePlannedItem(input: $input) {\n    id\n    enabled\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a81a143464bff59e649aa20dae3d6f2";

export default node;
